import { getSignedUrl } from "../services/utilities";

export const generalUtilMixin = {
  data() {
    return {
      loadingQueriesCount: 0,
    };
  },
  computed: {
    loading() {
      return this.loadingQueriesCount > 0;
    },
  },
  methods: {
    getScanName(item) {
      return item.friendlyName ? item.friendlyName : item.id;
    },
    async openInNewWindow(url) {
      const signedUrl = await getSignedUrl(url);
      window.open(signedUrl, "_blank");
    },
  },
};
